// extracted by mini-css-extract-plugin
export default {"note-create":"NoteNew_note-create__oK98G"};